// columnDef.ts
import { TitleGFC, TaskSummaryGFC, SalesNdStatusGFC, CustomerAddressGFC, ActionButtonsGFC } from "./GridComponents";

export const columnDef = [
    {
        headerName: "Project",
        field: "Name",
        flex: 1.5,
        cellRenderer: TitleGFC,
        autoHeight: true,
        wrapText: true,
        cellStyle: {
            display: "flex",
            alignItems: "center",
        },
    },
    {
        headerName: "Task Progress",
        field: "TaskSummary",
        flex: 1.2,
        cellRenderer: TaskSummaryGFC,
        cellStyle: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    },
    {
        headerName: "Status",
        field: "Status",
        width: 190,
        cellRenderer: SalesNdStatusGFC,
        cellStyle: {
            display: "flex",
            alignItems: "center",
        },
    },
    {
        headerName: "Customer Address",
        field: "CustomerStreet",
        flex: 1.5,
        cellRenderer: CustomerAddressGFC,
        cellStyle: {
            display: "flex",
            alignItems: "center",
        },
    },
    {
        headerName: "Actions",
        field: "actions",
        width: 170,
        cellRenderer: ActionButtonsGFC,
        cellStyle: {
            display: "flex",
            alignItems: "center",
        },
    },
];
